(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-wholesale"] && !Shopify.designMode) return;
  try {
    // The server always renders the Subscription Box defaulted to "apply_all". Any DOM
  // replacement of the drawer — this file's own refreshWholesaleCartDrawer(), stock
  // cart.js's quantity/remove (CartItems.updateQuantity), or stock cart-drawer.js's
  // AJAX add-to-cart (CartDrawer.renderContents) — pulls a fresh server render and would
  // silently reset the radio back to "Apply on all" otherwise. Persisting the shopper's
  // actual choice here (plain JS state, so it survives every DOM replacement regardless
  // of which code caused it) and restoring it centrally in bindWholesaleCartControls(),
  // which already runs after every single one of those replacements via the
  // MutationObserver below — that's the one place guaranteed to run no matter what
  // triggered the change.
  var wholesaleFrequencyMode = 'apply_all';

  function restoreFrequencyMode() {
    var box = document.querySelector('[data-frequency-mode-container]');
    if (!box) return;
    box.dataset.frequencyMode = wholesaleFrequencyMode;
    var radio = box.querySelector('[data-frequency-mode-radio][value="' + wholesaleFrequencyMode + '"]');
    if (radio) radio.checked = true;
  }

  function refreshWholesaleCartDrawer() {
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var source = html.querySelector('#CartDrawer .drawer__inner');
        var target = document.querySelector('#CartDrawer .drawer__inner');
        if (source && target) target.innerHTML = source.innerHTML;
      });
  }

  // /cart/change.js resets the line's quantity to 1 when `quantity` is omitted from the
  // request — it's not a partial patch of just the fields given. So the line's current
  // quantity has to be read from its input and sent along with every selling_plan change,
  // or a shopper's (possibly CMS-driven wholesale default) quantity gets silently wiped.
  function changeSellingPlan(line, sellingPlanId) {
    var quantityInput = document.getElementById('Drawer-quantity-' + line);
    var quantity = quantityInput ? quantityInput.value : undefined;
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, selling_plan: sellingPlanId, quantity: quantity }),
    });
  }

  // Same loader every quantity change already uses (theme-default .loading__spinner).
  // "Apply on all" genuinely updates every subscription line, so all of them spin;
  // an "Individual" line change only touches that one line, so only its own row should.
  // Neither needs an explicit hide afterward — refreshWholesaleCartDrawer() replaces the
  // whole box, and fresh markup comes in with spinners already correctly hidden.
  function showSubscriptionLoading() {
    document.querySelectorAll('[data-frequency-mode-container] .loading__spinner').forEach(function (spinner) {
      spinner.classList.remove('hidden');
    });
  }

  function showLineLoading(line) {
    var item = document.getElementById('CartDrawer-Item-' + line);
    var spinner = item ? item.querySelector('.loading__spinner') : null;
    if (spinner) spinner.classList.remove('hidden');
  }

  // These controls live inside <cart-drawer-items>, which (via stock cart.js's
  // CartItems base class) has its own delegated 'change' listener that assumes any
  // change came from a quantity input and tries to validate/parse it as one. Binding
  // directly on each control and calling stopPropagation() here stops that: per DOM
  // bubble order, a listener on the actual target always runs before a listener on an
  // ancestor (<cart-drawer-items>), regardless of registration time — a document-level
  // delegated listener would already be too late to prevent this.
  //
  // Rebinding is driven entirely by the MutationObserver below rather than being called
  // manually after refreshWholesaleCartDrawer(), because quantity/remove actions replace
  // this same DOM through stock cart.js's own path (CartItems.updateQuantity), which this
  // file has no hook into — only a mutation observer catches every replacement uniformly,
  // regardless of which code triggered it. restoreFrequencyMode() runs first, every time,
  // for the same reason — this function is the one guaranteed call site after any of the
  // three replacement paths.
  function bindWholesaleCartControls() {
    restoreFrequencyMode();

    document.querySelectorAll('[data-selling-plan-line-select]').forEach(function (select) {
      select.addEventListener('change', function (event) {
        event.stopPropagation();
        showLineLoading(select.dataset.line);
        changeSellingPlan(select.dataset.line, select.value).then(refreshWholesaleCartDrawer);
      });
    });

    document.querySelectorAll('[data-selling-plan-apply-all-select]').forEach(function (sharedSelect) {
      sharedSelect.addEventListener('change', function (event) {
        event.stopPropagation();
        var lines = sharedSelect.dataset.subscriptionLines.split(',').filter(Boolean);
        var chain = Promise.resolve();
        showSubscriptionLoading();
        lines.forEach(function (line) {
          chain = chain.then(function () {
            return changeSellingPlan(line, sharedSelect.value);
          });
        });
        chain.then(refreshWholesaleCartDrawer);
      });
    });

    document.querySelectorAll('[data-frequency-mode-radio]').forEach(function (radio) {
      radio.addEventListener('change', function (event) {
        event.stopPropagation();
        wholesaleFrequencyMode = radio.value;
        var box = radio.closest('[data-frequency-mode-container]');
        if (box) box.dataset.frequencyMode = radio.value;
      });
    });
  }

  bindWholesaleCartControls();

  // Observe #CartDrawer itself, not .drawer__inner or #CartDrawer-CartItems — there are
  // THREE different code paths that can replace this DOM, and they don't all preserve the
  // same nodes:
  //  - this file's own refreshWholesaleCartDrawer(): replaces .drawer__inner's content
  //    (.drawer__inner itself survives)
  //  - stock cart.js quantity/remove (CartItems.updateQuantity): also replaces
  //    .drawer__inner's content (.drawer__inner survives)
  //  - stock cart-drawer.js AJAX add-to-cart (CartDrawer.renderContents): replaces
  //    #CartDrawer's content directly — this DESTROYS AND RECREATES .drawer__inner itself
  //    as a new node, which is exactly why an observer watching .drawer__inner stopped
  //    firing after adding a product: it was left watching the old, now-detached node.
  // #CartDrawer is the only node none of the three paths ever remove, so it's the correct
  // thing to observe.
  var wholesaleCartDrawer = document.getElementById('CartDrawer');
  if (wholesaleCartDrawer) {
    new MutationObserver(bindWholesaleCartControls).observe(wholesaleCartDrawer, {
      childList: true,
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-box"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-wholesale-quantity]').forEach((qtyInput) => {
    var wrapper = qtyInput.closest('[data-wholesale-handles]');
    if (!wrapper) return;

    var handles = wrapper.dataset.wholesaleHandles.split(',').map(function (handle) {
      return handle.trim();
    }).filter(Boolean);
    if (!handles.length) return;

    var referrerPath = '';
    try {
      referrerPath = new URL(document.referrer).pathname;
    } catch (e) {
      return;
    }

    var cameFromWholesalePage = handles.some(function (handle) {
      return referrerPath === '/pages/' + handle || referrerPath === '/collections/' + handle;
    });
    if (!cameFromWholesalePage) return;

    qtyInput.value = qtyInput.dataset.wholesaleQuantity;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-selling-plan-select]').forEach((select) => {
    var priceTarget = document.getElementById(select.dataset.priceTarget);
    var form = select.closest('form');
    var sellingPlanInput = form ? form.querySelector('[data-selling-plan-input]') : null;

    function sync() {
      var option = select.selectedOptions[0];
      if (!option) return;
      if (priceTarget) priceTarget.textContent = option.dataset.price;
      if (sellingPlanInput) sellingPlanInput.value = option.value;
    }

    select.addEventListener('change', sync);
    sync();
  });
  } catch(e) { console.error(e); }
})();

})();
